import { Link } from "react-router-dom";
import { Lock, ShieldCheck, BadgeCheck, MailCheck, LogIn, ToggleRight } from "lucide-react";

const ACTIONS = {
  login: { to: "/accedi", label: "ACCEDI", icon: LogIn },
  verify_email: { to: "/profilo?tab=sicurezza", label: "VERIFICA EMAIL", icon: MailCheck },
  verify_identity: { to: "/profilo?tab=identita", label: "VERIFICA IDENTITÀ", icon: ShieldCheck },
  complete_certification: { to: "/profilo?tab=certificazione", label: "COMPLETA CERTIFICAZIONE", icon: BadgeCheck },
  consent: { to: "/profilo?tab=consensi", label: "GESTISCI CONSENSI", icon: ToggleRight },
};

export function LockNotice({ policy }) {
  if (!policy || policy.allowed) return null;
  const actions = [...new Set(policy.missing.map((m) => m.action))].filter((a) => ACTIONS[a]);
  return (
    <div data-testid="lock-notice" className="rounded-2xl border border-amber-200 bg-amber-50 p-4">
      <p className="flex items-center gap-2 font-display text-sm font-bold text-amber-900"><Lock className="h-4 w-4" /> Servizio bloccato: {policy.label}</p>
      <ul className="mt-2 space-y-1 text-sm text-amber-800">
        {policy.missing.map((m) => <li key={m.code} data-testid={`lock-missing-${m.code}`}>• {m.label}</li>)}
      </ul>
      <div className="mt-3 flex flex-wrap gap-2">
        {actions.map((a) => {
          const A = ACTIONS[a];
          return (
            <Link key={a} to={A.to} data-testid={`lock-action-${a}`} className="flex items-center gap-1.5 rounded-full bg-sky-600 px-4 py-1.5 text-xs font-bold tracking-wide text-white transition-colors hover:bg-sky-700">
              <A.icon className="h-3.5 w-3.5" /> {A.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export const PANEL_POLICY = {
  telemedicina: "PRENOTA_VIDEO_CONSULTO", domiciliare: "RICHIEDI_ASSISTENZA_DOMICILIARE", richieste: "RICHIEDI_IMPEGNATIVA",
  documenti: "CARICA_DOCUMENTI", agenda: "PRENOTA_VISITA", ai: "CHAT_SELVIX",
};
